var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        widget: _vm.widget,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
      },
    },
    [
      _c(
        "div",
        {
          key: _vm.widget.id,
          staticClass: "table-container",
          class: [_vm.selected ? "selected" : "", _vm.customClass],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectWidget(_vm.widget)
            },
          },
        },
        [
          _c("table", { staticClass: "table-layout" }, [
            _c(
              "tbody",
              _vm._l(_vm.widget.rows, function (row, rowIdx) {
                return _c(
                  "tr",
                  { key: row.id },
                  [
                    _vm._l(row.cols, function (colWidget, colIdx) {
                      return [
                        !colWidget.merged
                          ? _c("table-cell-widget", {
                              key: colWidget.id,
                              attrs: {
                                widget: colWidget,
                                designer: _vm.designer,
                                "parent-list": _vm.widget.cols,
                                "row-index": rowIdx,
                                "row-length": _vm.widget.rows.length,
                                "col-index": colIdx,
                                "col-length": row.cols.length,
                                "col-array": row.cols,
                                "row-array": _vm.widget.rows,
                                "parent-widget": _vm.widget,
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }